import React, {FC} from 'react';
import { ItemProps } from '../../types'
//import ValidationError from '../ValidationError';
import { Button } from '@/components/UiElements'

const Text: FC<ItemProps> = (
	{
		formItem,
		validation,
		disabled,
		formData,
		onChange,
		onFocus,
		onBlur,
		onKeyDown,
		autoFocus,

	}
) => {

	return (
		<>
			<Button
				onClick={()=> {
					if (formData[formItem.name]) {
						formData[formItem.name]?.(formItem, formData)
					} else {
						formItem?.itemOptions?.onClick?.(formItem, formData)}}
					}

				className= {
					`${formItem.classNames?.content || ""} `
				}
				disabled={formItem?.itemOptions?.buttonDisabled === undefined ? disabled : formItem?.itemOptions?.buttonDisabled}
				type={formItem?.itemOptions?.buttonType || 'primary'}
				size={formItem?.itemOptions?.buttonSize || 'md'}
			>
				{formItem?.itemOptions?.buttonLabel || formItem?.placeholder || "Submit"}
			</Button>



		</>
	);
};

export default Text;
